module.exports = __webpack_public_path__ + "img/stopandeat.9fa36c68.png";